export const  subscriptionLogConstants = {
    GET_SUBSCRIPTION_LOG_REQUEST: 'GET_SUBSCRIPTION_LOG_REQUEST',
    GET_SUBSCRIPTION_LOG_SUCCESS: 'GET_SUBSCRIPTION_LOG_SUCCESS',
    GET_SUBSCRIPTION_LOG_FAILURE: 'GET_SUBSCRIPTION_LOG_FAILURE',
}